import React from 'react'
import { Link } from 'react-router-dom';


const ATCRegistration = () => {

    

    return (
        <>

            <div className="inner-page-banner-area" style={{ backgroundImage: 'url("/images/About_images/about_banner.jpg")' }}>
                <div className="container">
                    <div className="pagination-area">
                        <h1>Institute Registration Process</h1>

                    </div>
                </div>
            </div>
            <div className='pagination-area text-center mt-5 mb-3'>
                <h1>Regular Franchise Registration</h1>

            </div>

            <div className="price-table2-area">
                <div className="container ">
                    <div className="row">
                        {/* <h1 className='text-center mt-3 mb-5 '>Franchise Registration</h1> */}
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow   ">
                            <div className="price-table-box1">
                                <span>BASIC <br />REGISTRATION</span>
                                <h2>₹5000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Parlor Institute & <br/> Fashion Designer Institute </font></p>
                                    {/* <p><font size={5}></font></p> */}
                                    <p><font size={5}>Basic Registration</font></p>
                                    <p><b>---Basic Kit---</b></p>
                                    <p>Registration Certificate</p>
                                    <p>Sticker</p>
                                    <p>Poster</p>
                                    <p>Sample Certificate</p>
                                    <p>Online Software</p>
                                </div>
                                <Link to="/atcdetails" className="pricetable-btn">View Details</Link> <br /> <br />
                                <Link to='/atcregform' className="pricetable-btn">Apply Online</Link>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow ">
                            <div className="price-table-box1">
                                <span>Standard-I <br />REGISTRATION</span>
                                <h2>₹7500/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Computer  & Technical Institute For <br /> Regular Courses </font></p>
                                    <p><font size={5}></font></p>
                                    <p><font size={5}>Standard Registration</font></p>
                                    <p><b>---Basic Kit---</b></p>
                                    <p>Registration Certificate</p>
                                    <p>Sticker</p>
                                    <p>Poster</p>
                                    <p>Sample Certificate</p>
                                    <p>Online Software</p>
                                </div>
                                <Link to="/atcdetails" className="pricetable-btn">View Details</Link> <br /> <br />
                                <Link to='/atcregform' className="pricetable-btn">Apply Online</Link>                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow ">
                            <div className="price-table-box1">
                                <span>Standard -II <br />REGISTRATION</span>
                                <h2>₹11000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Advance Courses</font></p>
                                    <p><font size={5}>Training Center</font></p>
                                    <p><font size={5}>Standard Registration</font></p>
                                    <p><b>---Basic Kit---</b></p>
                                    <p>Registration Certificate</p>
                                    <p>Sticker</p>
                                    <p>Poster</p>
                                    <p>Sample Certificate</p>
                                    <p>Online Software</p>
                                </div>
                                <Link to="/atcdetails" className="pricetable-btn">View Details</Link> <br /> <br />
                                <Link to='/atcregform' className="pricetable-btn">Apply Online</Link>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow ">
                            <div className="price-table-box1">
                                <span>Preminum <br /> Registration</span>
                                <h2>₹15000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Computer Institute with</font></p>
                                    <p><font size={5}>Marketing Support</font></p>
                                    <p><font size={5}>Premium Registration</font></p>
                                    <p><b>---Basic Kit---</b></p>
                                    <p>Marketing Team Support</p>
                                    <p>*Brouchers for 9 Months and</p>
                                    <p>12 Diploma. (2000 Nos)</p>
                                    <p>(D.ITT) - 12 Months Duration</p>
                                    <p>(D.ITA) - 9 Months Duration</p>
                                </div>
                                <Link to="/atcdetails" className="pricetable-btn">View Details</Link> <br /> <br />
                                <Link to='/atcregform' className="pricetable-btn">Apply Online</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="price-table1-area">
                <div className="container ">
                    <div className="row">
                        <h1 className='text-center mt-3 mb-5 '>Franchise Registration</h1>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow   ">
                            <div className="price-table-box1">
                                <span>SILVER-I <br />REGISTRATION</span>
                                <h2>₹500000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Single Franchise</font></p>
                                    <p><font size={5}>Registration</font></p>
                                    <p><font size={5}>With Marketing Support</font></p>
                                </div>
                                <Link to='/contact' className="pricetable-btn">Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow ">
                            <div className="price-table-box1">
                                <span>SILVER-II <br />REGISTRATION</span>
                                <h2>₹700000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Tier-1 cities</font></p>
                                    <p><font size={5}>Franchise Registration</font></p>
                                    <p><font size={5}>With Marketing Support</font></p>
                                </div>
                                <Link to='/contact'className="pricetable-btn"> Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow ">
                            <div className="price-table-box1">
                                <span>GOLD <br />REGISTRATION</span>
                                <h2>₹900000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>Tier-1 cities</font></p>
                                    <p><font size={5}>Franchise Registration</font></p>
                                    <p><font size={5}>With Marketing Support</font></p>
                                </div>
                                <Link to='/contact' className="pricetable-btn">Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-xs-9   hvr-float-shadow ">
                            <div className="price-table-box1">
                                <span>STATE MASTER FRANCHISE</span>
                                <h2>₹4000000/-</h2>
                                <div className="price-table-service">
                                    <p><font size={5}>State Franchise</font></p>
                                    <p><font size={5}>Registration</font></p>
                                    <p><font size={5}>With Marketing Support</font></p>
                                </div>
                                <Link to='/contact' className="pricetable-btn">Contact Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ATCRegistration